import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from "@angular/common";

import { Visit } from './interface/visit';
import { ListFormat } from './interface/list-format';
import { FieldDefinition } from './interface/field-definition';

import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription, MatAccordion } from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import * as FLOWCHART_DATA from '../../../../assets/tests/data/flowchart.json' 
import * as LSTFORMAT_DATA from '../../../../assets/tests/data/listsFormat.json'


@Component({
  selector: 'flowchart',
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    MatAccordion,
    MatIconModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    NgClass
],
  templateUrl: './flowchart.html',
  styleUrl: './flowchart.scss'
})
export class Flowchart {
  @Output() loadingComplete = new EventEmitter<void>();

  lstVisite: Visit[] = (FLOWCHART_DATA as any).default as Visit[];

  lstFormat: ListFormat[] = (LSTFORMAT_DATA as any).default as ListFormat[];

  DEFAULT_LIST_FORMAT:ListFormat = {code:'UNKNOW', label:'Not Found', values:[{value:0,i18nCodeLabel:"List not found",sasLabel:"LIST NOT FOUND"}]}

  lstFormatMap = new Map<string, ListFormat>()
  
  //champs répétable, ne sert pas pour le moment (mauvaise approche)
  formGroupedFieldMap = new Map<String, FieldDefinition[]>()

  constructor() {
    //transformation de la liste de Format en Map de Format indexée par code
    this.lstFormat.forEach(f => this.lstFormatMap.set(f.code,f))

    //gestion champs répétable, ne sert pas pour le moment (mauvaise approche)
    //stockage des groupe de champs répétables
    let formFieldTmpLst:FieldDefinition[] = []

    this.lstVisite.forEach(visit =>
        visit.forms.forEach(form => 
          form.fields.forEach(field => {
              const groupLabel = field.metaData['LABEL_FOR_GROUPE_REPEATED']
              const isRepeated = field.metaData['GROUPE_REPEATED']
              const codeForMap = form.code + '_' + groupLabel

              if (isRepeated && groupLabel) {
                if (!this.formGroupedFieldMap.has(codeForMap)) {
                  this.formGroupedFieldMap.set(codeForMap, [])
                }

                this.formGroupedFieldMap.get(codeForMap)?.push(field)
              }
          }
          )//end foreach field
        )//end foreach form
    )//end foreach visit
  }
  
  ngOnInit():void {
    console.log("DynamicForm ngOnInit " + new Date())
  }

  ngAfterContentInit():void {
    console.log("DynamicForm ngAfterContentInit " + new Date())
  }  

  ngAfterViewInit():void {
    console.log("DynamicForm ngAfterViewInit " + new Date())
    this.loadingComplete.emit();
  } 
  
  // Cette méthode transforme l'objet JS en un tableau de [clé, valeur]
  getMetaDataEntries(metaData: { [key: string]: any }): [string, any][] {
    if (!metaData) {
      return [];
    }
    // Object.entries() retourne un tableau de tableaux : [['LIST_CODE', 'NOYES.'], ['IESEQ', '1'], ...]
    return Object.entries(metaData);
  }

  dump(obj:any) {
    console.log(JSON.stringify(obj))
  }
}
